import { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
export const useMap = ({ onLoad, center, zoom, style = 'light' }) => {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    // const [map, setMap] = useState<mapboxgl.Map | null>(null);
    const mapBoxRef = useRef(null);
    const mapRef = useRef(null);
    const getMapStyle = () => {
        switch (style) {
            case 'light':
                return 'mapbox://styles/mapbox/light-v10';
            case 'satellite':
                return 'mapbox://styles/mapbox/satellite-streets-v12';
            case 'default':
                return 'mapbox://styles/mapbox/streets-v12';
            default:
                return 'mapbox://styles/mapbox/light-v10';
        }
    };
    useEffect(() => {
        const useEffectRef = mapBoxRef.current;
        if (mapRef.current && !useEffectRef) {
            // Initialize map
            mapboxgl.accessToken = 'pk.eyJ1IjoibHVjc291cmd1bSIsImEiOiJjbGE5dGc1ZHIwMWJkM25ud3Vrbzd1N2lxIn0.jALyAIrgB-YWlPilyAKq8A';
            const mapInstance = new mapboxgl.Map({
                container: mapRef.current,
                // style: 'mapbox://styles/lucsourgum/cluk17x3r03nt01nwc466dtb5',
                style: getMapStyle(),
                center: center || [-70.9, 42.35],
                zoom: zoom || 5,
            });
            mapBoxRef.current = mapInstance;
            mapInstance.on('load', () => {
                onLoad(mapInstance);
            });
        }
        //cleanup function
        return () => {
            if (useEffectRef) {
                mapBoxRef.current?.remove();
                mapBoxRef.current = null;
            }
        };
    }, []);
    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { width, height } = entry.contentRect;
                if (width > dimensions.width || height > dimensions.height) {
                    if (mapBoxRef.current) {
                        mapBoxRef.current.resize();
                    }
                    setDimensions({ width, height });
                }
            }
        });
        if (mapRef.current) {
            resizeObserver.observe(mapRef.current);
        }
        return () => {
            if (mapRef.current) {
                resizeObserver.unobserve(mapRef.current);
            }
            resizeObserver.disconnect();
        };
    }, [mapRef.current, dimensions]);
    return { map: mapBoxRef.current, mapRef };
};
//# sourceMappingURL=useMap.js.map